<template>
  <div>
    <v-checkbox
        class="pt-6"
        :error-messages="error"
        v-model="isChecked"
        :label="translation(translationList.politically_exposed_agreement, 'Sunt persoană expusă politic')"
    ></v-checkbox>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'CustomerIsPoliticallyExposed',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
    customerIndex: Number as () => number | null,
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      if (props.customerIndex !== undefined) {
        emit('validation-customer-status', {field: `is_politically_exposed-${props.customerIndex}`, isValid});
      } else {
        emit('validation-customer-status', {field: 'is_politically_exposed', isValid});
      }
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-terms', (data) => {
        if (data.detail && (data.detail === `is_politically_exposed-${props.customerIndex}` || data.detail === 'is_politically_exposed')) {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_politically_exposed, 'Te rugăm să confirmi dacă ești o persoana expusa politic pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-customer-status', {field: data.detail, isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>